import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, Mail, CheckCircle2, Clock } from "lucide-react";

export default function SubscribersTab() {
  const [data, setData] = useState({ subscribers: [], total: 0, verified: 0 });

  useEffect(() => {
    api.get("/admin/subscribers").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const exportCsv = () => {
    const rows = [["email", "status", "source", "created_at", "verified_at"]];
    data.subscribers.forEach((s) => rows.push([s.email, s.status, s.source, s.created_at, s.verified_at]));
    const csv = rows.map((r) => r.map((v) => `"${(v || "").toString().replace(/"/g, '""')}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = `nc-mycology-subscribers-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a); a.click(); a.remove();
  };

  return (
    <div data-testid="subscribers-tab">
      <div className="flex items-center justify-between mb-4 gap-4 flex-wrap">
        <div className="flex gap-6">
          <div><p className="font-mono-label text-[10px] text-muted-foreground">Total</p><p className="font-display text-2xl">{data.total}</p></div>
          <div><p className="font-mono-label text-[10px] text-muted-foreground">Verified</p><p className="font-display text-2xl text-primary">{data.verified}</p></div>
        </div>
        <Button variant="outline" onClick={exportCsv} disabled={!data.total} data-testid="subscribers-export"
          className="rounded-full font-mono-label text-[11px]">
          <Download className="w-3.5 h-3.5 mr-1.5" /> Export CSV
        </Button>
      </div>

      <div className="border border-border divide-y divide-border" data-testid="subscribers-list">
        <div className="grid grid-cols-12 px-4 py-3 font-mono-label text-[10px] text-muted-foreground bg-card">
          <span className="col-span-6">Email</span><span className="col-span-3">Status</span><span className="col-span-3">Joined</span>
        </div>
        {data.subscribers.length === 0 && <p className="px-4 py-8 text-muted-foreground text-sm">No subscribers yet.</p>}
        {data.subscribers.map((s) => (
          <div key={s.email} className="grid grid-cols-12 px-4 py-3 text-sm items-center">
            <span className="col-span-6 truncate flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-muted-foreground shrink-0" />{s.email}</span>
            <span className="col-span-3">
              {s.status === "verified"
                ? <span className="inline-flex items-center gap-1 font-mono-label text-[9px] text-primary border border-primary/40 px-2 py-1"><CheckCircle2 className="w-3 h-3" /> VERIFIED</span>
                : <span className="inline-flex items-center gap-1 font-mono-label text-[9px] text-muted-foreground border border-border px-2 py-1"><Clock className="w-3 h-3" /> PENDING</span>}
            </span>
            <span className="col-span-3 font-mono text-[10px] text-muted-foreground">{s.created_at ? new Date(s.created_at).toLocaleDateString() : "—"}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
